import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, ApiError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { AuthLayout } from "./AuthLayout";
import { Alert, Button, Field, Input } from "../components/ui";

export function Login() {
  const navigate = useNavigate();
  const { setMe } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.login({ email, password });
      // Login returns the user but not the org, so read the full context back
      // rather than rendering a header with a missing company name.
      setMe(await api.me());
      navigate("/app", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Something went wrong.");
      setBusy(false);
    }
  }

  return (
    <AuthLayout>
      <div className="mb-8">
        <h1 className="text-[2rem] leading-tight font-bold tracking-tight">Sign in</h1>
        <p className="mt-1.5 text-[1rem] text-ink-soft">to your operation's fleet</p>
      </div>

      <form onSubmit={onSubmit} className="flex flex-col gap-5" noValidate>
        {error && <Alert>{error}</Alert>}

        <Field label="Email">
          {(id) => (
            <Input
              id={id}
              type="email"
              autoComplete="username"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ops@youroperation.com"
            />
          )}
        </Field>

        <Field label="Password">
          {(id) => (
            <Input
              id={id}
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          )}
        </Field>

        <Button type="submit" busy={busy}>
          Sign in
        </Button>
      </form>

      <p className="mt-8 text-[0.9rem] text-ink-soft">
        No account yet?{" "}
        <Link to="/signup" className="font-semibold text-accent-text hover:underline underline-offset-4">
          Set up your organisation
        </Link>
      </p>
    </AuthLayout>
  );
}
